import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";

export default function Register() {
  const [searchParams] = useSearchParams();
  const tokenVal = searchParams.get("token") || "";
  const [fullName, setFullName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!tokenVal) { setError("Missing invite token"); return; }
    setError("");
    setLoading(true);
    try {
      await register(tokenVal, fullName, jobTitle, password);
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4" data-testid="register-page">
      <Card className="w-full max-w-md rounded-xl border bg-card shadow-lg">
        <CardContent className="p-8">
          <div className="text-center mb-8">
            <img src="/varyynt-logo-wide.svg" alt="Varyynt" className="h-10 w-auto mx-auto mb-3" />
            <h2 className="text-lg font-heading text-evergreen-950">Join Varyynt Intel</h2>
            <p className="text-sm text-slate-500 font-accent mt-2">Complete your registration</p>
          </div>
          {!tokenVal && (
            <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-700 mb-4">
              No invite token found. You need a valid invite link to register.
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label className="text-xs font-mono uppercase tracking-widest text-slate-400 mb-2 block">Full Name</Label>
              <Input data-testid="register-name-input" value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="Your full name" required />
            </div>
            <div>
              <Label className="text-xs font-mono uppercase tracking-widest text-slate-400 mb-2 block">Job Title</Label>
              <Input data-testid="register-title-input" value={jobTitle} onChange={(e) => setJobTitle(e.target.value)} placeholder="e.g. VP Talent Acquisition" required />
            </div>
            <div>
              <Label className="text-xs font-mono uppercase tracking-widest text-slate-400 mb-2 block">Password</Label>
              <Input data-testid="register-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Choose a password" required />
            </div>
            {error && <p data-testid="register-error" className="text-sm text-destructive">{error}</p>}
            <Button data-testid="register-submit-btn" type="submit" disabled={loading || !tokenVal} className="w-full bg-evergreen-950 hover:bg-evergreen-900 text-white">
              {loading ? "Creating account..." : "Create Account"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
